var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconShare2 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.7 6.70039L11 4.40039V15.0004C11 15.6004 11.4 16.0004 12 16.0004C12.6 16.0004 13 15.6004 13 15.0004V4.40039L15.3 6.70039C15.5 6.90039 15.7 7.00039 16 7.00039C16.3 7.00039 16.5 6.90039 16.7 6.70039C17.1 6.30039 17.1 5.70039 16.7 5.30039L12.7 1.30039C12.6 1.20039 12.5 1.10039 12.4 1.10039C12.2 1.00039 11.9 1.00039 11.6 1.10039C11.5 1.20039 11.4 1.20039 11.3 1.30039L7.3 5.30039C6.9 5.70039 6.9 6.30039 7.3 6.70039C7.7 7.10039 8.3 7.10039 8.7 6.70039Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 13C3 11.3431 4.34315 10 6 10H8C8.55228 10 9 10.4477 9 11C9 11.5523 8.55228 12 8 12H6C5.44772 12 5 12.4477 5 13V20C5 20.5523 5.44772 21 6 21H18C18.5523 21 19 20.5523 19 20V13C19 12.4477 18.5523 12 18 12H16C15.4477 12 15 11.5523 15 11C15 10.4477 15.4477 10 16 10H18C19.6569 10 21 11.3431 21 13V20C21 21.6569 19.6569 23 18 23H6C4.34315 23 3 21.6569 3 20V13Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconShare2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/IconShare2.e66c5082d7a02f16725f69938f8d9760.svg";